import { createAuthClient } from 'better-auth/react';
import { polarClient } from '@polar-sh/better-auth/client';
import { adminClient, magicLinkClient } from 'better-auth/client/plugins';

// In development, use empty baseURL so requests go through Vite proxy (same-origin)
// This ensures cookies work correctly with same-origin requests
// In production, set VITE_API_URL to the actual API URL
const apiUrl = import.meta.env.DEV ? '' : import.meta.env.VITE_API_URL || '';

export const authClient = createAuthClient({
  baseURL: apiUrl,
  basePath: '/api/auth',
  plugins: [polarClient(), adminClient(), magicLinkClient()],
  fetchOptions: {
    credentials: 'include', // Always include credentials for session cookies
  },
});

export const { signIn, signOut, signUp, useSession, getSession } = authClient;
